module["exports"] = [
  "#{street_root}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de/address/street_name.js
// module id = 1309
// module chunks = 0